import React, { useState, useEffect, ReactEventHandler } from 'react';
import styled from 'styled-components';
import { key } from 'styled-theme';
import axios from 'axios';
import { NextRouter } from 'next/dist/next-server/lib/router/router';

import { INTEGRATION_THEME } from 'constants/index';
import app from 'components/app';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import { useTranslation } from 'lib/i18n';

import list from './list';

const Iframe = styled.iframe`
  width: 800px;
  height: ${props => props.height};
  border-radius: ${key('sizes.borderRadius')};
`;

const FilesIndex: React.FC<{ url: NextRouter }> = props => {
  const { t, i18n } = useTranslation('pages');
  const id = props.url.query.id as keyof typeof list;
  const [iframeProps, setIframeProps] = useState<{
    srcDoc: string;
    frameBorder: number;
    height?: number;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const onIframeLoad: ReactEventHandler<HTMLIFrameElement> = event => {
    const frame = event.target as HTMLIFrameElement;
    const iframe = frame.contentDocument || frame.contentWindow?.document;
    if (iframe) {
      iframe.body.style.overflow = 'hidden';
    }
    const links = iframe?.getElementsByTagName('a') || [];
    for (let i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
    }
    if (
      iframe &&
      iframeProps &&
      iframe.body.scrollHeight !== iframeProps.height
    ) {
      setIframeProps(prevProps =>
        prevProps
          ? {
              ...prevProps,
              height: iframe.body.scrollHeight,
            }
          : null,
      );
    }
  };
  useEffect(() => {
    const listItem = list[id];
    if (listItem !== undefined) {
      const lang = i18n.language;
      const { src } =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        listItem[lang] || listItem[listItem.defaultLanguage];
      axios
        .get(`${src}?embedded=true`)
        .then(response =>
          setIframeProps(prevState => ({
            ...(prevState ?? {}),
            srcDoc: response.data,
            frameBorder: 0,
          })),
        )
        .catch(() => setError(true))
        .then(() => setLoading(false));
    }
  }, []);
  const PageWrapper: React.FC = ({ children }) => (
    <Page title={t('integration.title')} footer noPadding scrollingHeader>
      <Section>
        <Wrapper>{children}</Wrapper>
      </Section>
    </Page>
  );

  if (loading) {
    return (
      <PageWrapper>
        <H1>Loading...</H1>
      </PageWrapper>
    );
  }

  if (!error && iframeProps !== null) {
    return (
      <PageWrapper>
        <Iframe {...iframeProps} onLoad={onIframeLoad} />
      </PageWrapper>
    );
  }
  return (
    <PageWrapper>
      <H1>File not found</H1>
    </PageWrapper>
  );
};

export default app(FilesIndex, {
  theme: INTEGRATION_THEME,
});
